// API URL configuration - USE PROXY to avoid CORS issues
export const API_BASE_URL = '/api';

/**
 * Public origin of the external check-in SWA (the `sm4rt-checkin-web` repo,
 * served at `checkin.techsolvers.com.au`). Staff copy/send customer intake
 * links built from this — they must point at that public, no-MSAL app, NOT at
 * this staff app's own origin.
 *
 * Defaults to production so a normal build needs no extra config; local dev
 * overrides it to the check-in app's dev server via `REACT_APP_CHECKIN_BASE_URL`
 * in `web/.env` (port 3001 — see the port registry). CRA only exposes
 * `REACT_APP_*` vars to the bundle.
 */
export const CHECKIN_PUBLIC_BASE_URL = (
  process.env.REACT_APP_CHECKIN_BASE_URL || 'https://checkin.techsolvers.com.au'
).replace(/\/+$/, '');

/**
 * Customer intake link for a session token. The token sits at the root of the
 * check-in domain (`checkin.techsolvers.com.au/<token>`) — the domain already
 * says "check-in", and the short path keeps SMS messages inside one segment.
 */
export const buildCheckInIntakeLink = (token: string): string =>
  `${CHECKIN_PUBLIC_BASE_URL}/${encodeURIComponent(token)}`;
